import type { EquipmentRequestModel } from 'ab-requestModels/equipment.requestModel';

import { isValidTextInput } from '@acceligentllc/shared/utils/text';

import { EQUIPMENT_ID_REGEX } from '@acceligentllc/shared/constants/regex';

const ALNUM_25 = /^[A-Za-z0-9]{1,25}$/;
const ALNUM_17 = /^[A-Za-z0-9]{1,17}$/;
const ALNUM_EXACTLY_9 = /^[A-Za-z0-9]{9}$/;
const ALNUM_EXACTLY_2 = /^[A-Za-z0-9]{2}$/;
const SIX_DIGITS = /^\d{1,6}$/;      // allow 1-6 so leading zeros aren’t forced

export function validate(values: EquipmentRequestModel) {
	const errors: ValidationErrors = {};

	if (!values.equipmentCost) {
		errors.equipmentCost = 'Equipment Cost is required';
	}

	if (!isValidTextInput(values.code)) {
		errors.code = 'Equipment code is required';
	} else if (!EQUIPMENT_ID_REGEX.test(values.code)) {
		errors.code = 'Invalid code pattern. Check ? from help.';
	}

	if (values.vinNumber && !ALNUM_17.test(values.vinNumber)) {
		errors.vinNumber = 'VIN must be between 1 and 17 alphanumeric characters';
	}

	if (values.gvw && !SIX_DIGITS.test(String(values.gvw))) {
		errors.gvw = 'GVW must be a 1-6 digit number';
	}

	if (values.make && !ALNUM_25.test(values.make)) {
		errors.make = 'Make can only contain letters & numbers (max 25)';
	}

	if (values.model && !ALNUM_25.test(values.model)) {
		errors.model = 'Model can only contain letters & numbers (max 25)';
	}

	if (values.driversAlertId && !ALNUM_25.test(values.driversAlertId)) {
		errors.driversAlertId = 'Drivers Alert ID must be alphanumeric (max 25)';
	}

	if (values.tollPassId && !ALNUM_25.test(values.tollPassId)) {
		errors.tollPassId = 'Toll Pass ID must be alphanumeric (max 25)';
	}

	if (values.hutNumber && !ALNUM_25.test(values.hutNumber)) {
		errors.hutNumber = 'HUT Number must be alphanumeric (max 25)';
	}

	if (values.plateNumber && !ALNUM_EXACTLY_9.test(values.plateNumber)) {
		errors.plateNumber = 'Plate Number must be alphanumeric (exactly 9)';
	}

	if (values.plateType && !ALNUM_EXACTLY_9.test(values.plateType)) {
		errors.plateType = 'Plate Type must be alphanumeric (exactly 9)';
	}

	if (values.registrationState && !ALNUM_EXACTLY_2.test(values.registrationState)) {
		errors.registrationState = 'Registration State must be alphanumeric (exactly 2)';
	}

	return errors;
}
